
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Browse extends Vue {
  mounted() {
    this.$router.push("/cases");
  }
}
